import { useState } from 'react'
import classNames from 'classnames'
import copy from 'copy-to-clipboard'
import '../../styles/share.scss'

const Share = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [isCopied, setIsCopied] = useState(false)

    const openPopup = (url) => {
        window.open(url, "",'height=400,width=600');
    }

    const shareTwitter = () => {
        const message = "I'm listening to Ronik's Holiday Playlist Multiverse 2022";
        const url = `https://twitter.com/intent/tweet/?text=${message}&url=${window.location.href}&via=ronikdesign`

        openPopup(url)
    }

    const shareFacebook = () => {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`;

        openPopup(url)
    }

    const copyURL = () => {
        const message = `I'm listening to Ronik's Holiday Playlist Multiverse 2022: ${window.location.href}`;

        copy(message, {
            format: 'text/plain',
            onCopy: () => {
                setIsCopied(true)
            }
        });
    }

    const shareClasses = classNames({
        'share': true,
        'is-open': isOpen,
        'is-copied': isCopied
    });

    return (
        <div className={shareClasses}>
            <button className="share__toggle" onClick={() => { setIsOpen(!isOpen) }}>
                <img src={'/assets/share-this.svg'} className="share__open" />
                <img src={'/assets/back.svg'} className="share__close" />
            </button>

            <span className="share__tag">Copied!</span>

            <ul className="share__list">
                <li>
                    <button className="share__button" onClick={() => { shareTwitter() }}>
                        <span className="share__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-203.9 435.1 399.9 325.2">
                                <path d="M196 473.6c-14.7 6.5-30.5 10.9-47.1 12.9 16.9-10.2 30-26.2 36.1-45.4-15.9 9.4-33.4 16.2-52.1 19.9-15-15.9-36.3-25.9-59.9-25.9-45.3 0-82.1 36.7-82.1 82.1 0 6.4.7 12.7 2.1 18.7-68.2-3.4-128.7-36.1-169.1-85.7-7.1 12.1-11.1 26.2-11.1 41.3 0 28.5 14.5 53.6 36.5 68.3-13.5-.4-26.1-4.1-37.2-10.3v1c0 39.8 28.3 72.9 65.8 80.5-6.9 1.9-14.1 2.9-21.6 2.9-5.3 0-10.4-.5-15.4-1.5 10.4 32.6 40.8 56.3 76.7 57-28.1 22-63.5 35.1-101.9 35.1-6.6 0-13.2-.4-19.6-1.1 36.3 23.3 79.5 36.9 125.8 36.9 150.9 0 233.5-125 233.5-233.5 0-3.6-.1-7.1-.2-10.6 15.9-11.7 29.8-26.2 40.8-42.6z"/>
                            </svg>
                        </span>
                    </button>
                </li>

                <li>
                    <button className="share__button" onClick={() => { shareFacebook() }}>
                        <span className="share__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-107.9 398 207.9 400">
                                <path d="M26.2 798V615.6h61.9c3.1-23.7 6.1-47 9.3-71h-71c0-17.5-.5-34.4.1-51.3.7-19.3 11.8-26.5 27.4-27.4 9.2-.5 18.4-.5 27.6-.7 6.1-.1 12.3 0 18.5 0V399c-22.8-.3-45.2-1.5-67.6-.7-16.7.6-32.5 6.3-46.1 16.5-22.8 17.2-32 41.3-33.4 68.7-.9 18.2-.2 36.5-.2 54.8v6.6h-60.6v70.8h60.1v181.9"/><path d="M26.2 798V615.6h61.9c3.1-23.7 6.1-47 9.3-71h-71c0-17.5-.5-34.4.1-51.3.7-19.3 11.8-26.5 27.4-27.4 9.2-.5 18.4-.5 27.6-.7 6.1-.1 12.3 0 18.5 0V399c-22.8-.3-45.2-1.5-67.6-.7-16.7.6-32.5 6.3-46.1 16.5-22.8 17.2-32 41.3-33.4 68.7-.9 18.2-.2 36.5-.2 54.8v6.6h-60.6v70.8h60.1v181.9l74 .4z"/>
                            </svg>
                        </span>
                    </button>
                </li>

                <li>
                    <button className="share__button" onClick={() => { copyURL() }}>
                        <span className="share__icon">
                            <svg viewBox="0 0 412 505" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M275.995,-0.3316667 C299.464835,-0.3316667 319.3266,20.9658193 319.3266,42.9999333 L319.3257,47.3293333 L345.996333,47.3296667 C363.408185,47.3296667 380.109919,54.2476714 392.434268,66.5654542 C404.745746,78.8825134 411.663967,95.5849424 411.663967,112.9973 L411.663967,439.6593 C411.663967,457.072864 404.744601,473.776147 392.431224,486.089524 C380.115495,498.405253 363.412415,505.322267 345.996333,505.322267 L66.0003333,505.322267 C48.5847583,505.322267 31.8823717,498.405469 19.5654426,486.089524 C7.25216934,473.776251 0.33269999,457.072544 0.33269999,439.6593 L0.33269999,112.9973 C0.33269999,95.5854487 7.25070464,78.8837141 19.5684875,66.559365 C31.8855467,54.247887 48.5879757,47.3296667 66.0003333,47.3296667 L92.6647,47.3293333 L92.6654,42.9999333 C92.6654,19.3070277 111.678856,0.0567740278 135.280412,-0.325861755 L135.997,-0.3316667 L275.995,-0.3316667 Z M319.3266,89.6682666 C319.3266,113.600495 299.927094,132.999867 275.995,132.999867 L135.997,132.999867 C112.527165,132.999867 92.6654,111.702381 92.6654,89.6682666 L92.6647,85.3293333 L66.0003333,85.3293333 C58.664661,85.3293333 51.6246478,88.2456715 46.4390815,93.4288848 C41.2486776,98.6220569 38.3327,105.661931 38.3327,112.9973 L38.3327,439.6593 C38.3327,446.993921 41.2483292,454.032295 46.4349631,459.218929 C51.6244842,464.408036 58.6616443,467.322267 66.0003333,467.322267 L345.996333,467.322267 C353.335326,467.322267 360.372624,464.408008 365.561166,459.219466 C370.748477,454.032156 373.663967,446.994191 373.663967,439.6593 L373.663967,112.9973 C373.663967,105.661628 370.747962,98.6216145 365.564749,93.4360482 C360.371576,88.2456443 353.331702,85.3293333 345.996333,85.3293333 L319.3257,85.3293333 L319.3266,89.6682666 Z M275.988201,39.6692827 L135.997,39.6683333 C134.156234,39.6683333 132.6654,41.1591573 132.6654,42.9999333 L132.6654,89.3103333 L132.705527,89.4234926 L132.747421,89.5304337 L132.798236,89.6499951 C133.076781,90.2815952 133.545462,90.9886871 134.125279,91.6104159 C134.675297,92.2001929 135.249869,92.6347078 135.73355,92.8723241 L136.00053,92.9954726 L275.995,92.9998666 C277.835766,92.9998666 279.3266,91.5090427 279.3266,89.6682666 L279.3266,43.3593333 L279.286473,43.2447073 L279.244579,43.1377663 L279.193764,43.0182049 C278.915219,42.3866047 278.446538,41.6795128 277.866721,41.057784 C277.316703,40.4680071 276.742131,40.0334921 276.25845,39.7958758 L276.00545,39.6795613 L275.988201,39.6692827 Z" id="Shape"></path>
                            </svg>
                        </span>
                    </button>
                </li>
            </ul>
        </div>
    );
}

export default Share;